import {EmailConfigurationItem} from "../../model/EmailConfigurationItem";
import ServiceEndpoints from "../ServiceEndpoints";
import {SearchResultItem} from "../../model/SearchResultItem";
import {ContactItem} from "../../model/ManagePOIListItem";

export async function sharedEmailsForm(sharedEmails: EmailConfigurationItem, token: string | undefined): Promise<EmailConfigurationItem> {
    const emailOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify(sharedEmails),
    };

    try {
        const response = await fetch(ServiceEndpoints.EmailConfiguration, emailOptions);

        if (response.status === 200) {
            const data = await response.json();
            return data as EmailConfigurationItem;
        } else {
            const errorJson = await response.json();
            throw new Error(JSON.stringify(errorJson));
        }
    } catch (error) {
        console.error("API error " + error);
        let messages: string[] | undefined = undefined;
        let invalidCharsFlag: boolean | undefined = undefined;

        try {
            const parsed = JSON.parse(error.message);
            if (Array.isArray(parsed.errors)) {
                messages = parsed.errors;
                invalidCharsFlag = true;
            } else if (typeof parsed === "string") {
                messages = undefined;
            }
        } catch (parseErr) {
            messages = undefined;
        }

        return {
            caDataManagersSharedEmail: "",
            caEndUsersSharedEmail: "",
            messages,
            invalidCharsFlag
        };
    }
}

export async function fetchEmailConfiguration(userToken?: string | undefined) {
    return await fetch(ServiceEndpoints.FetchEmailConfiguration, {
        method: 'GET',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + userToken },
    }).then(async (resp) => {
        const data: EmailConfigurationItem = await resp.json();
        return data;
    }).catch((error) => {
        console.error(error);
        return {
            caDataManagersSharedEmail: "",
            caEndUsersSharedEmail: "",
            lastUpdatedCADataManagersSharedEmail: undefined,
            lastUpdatedCaEndUsersSharedEmail: undefined
        };
    });
}